// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/quest/mission_map_banner.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/quest/mission_map_banner_icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 미션 상태 지도 (Figma 2483:75533).
 *
 * 🔴 좌표 정합의 핵심은 CSS 계산이 아니라 **구조**다.
 *    \`.msm-stage\` 가 \`<img>\` 를 감싸 **이미지 렌더 크기 그대로** 줄어들고, 마커는 그 안에서
 *    \`%\` 로 놓인다. 그래서 화면 해상도·화면비가 무엇이든 마커가 지도 위 같은 지점에 붙는다.
 *    (안내판에서 vw/vh 로 좌표를 계산하다 16:10 이 아닌 화면에서 어긋난 사고의 교훈 —
 *     계산을 없애는 쪽이 계산을 맞추는 쪽보다 안전하다.)
 *
 * 크기·타이포는 디자인 1920×1200 기준을 적고 \`--msm-u\`(디자인 1px 의 실제 길이)로 환산한다.
 */

.msm {
  /* 안내판과 같은 규약 — 확대하지 않고 비율을 지킨다(min). @supports 가 아래에서 덮어쓴다. */
  --msm-u: 0.667px;

  position: fixed;
  inset: 0;
  /* 🔴 헤더를 지도 **위에 겹치지 않고 위쪽에 쌓는다**(사용자 요청 2026-08-05).
     디자인(2483:75533)은 알약이 지도 위에 떠 있으나, 실제 지도는 상단까지 내용이 차 있어
     글자가 지도를 가렸다. 세로 흐름으로 바꿔 헤더 아래에 지도가 오게 한다. */
  /* 🔴 2026-08-19 — 쌓기(flex column) → **절대배치**로 바꿨다. 새 Figma 는 지도와 배너의
     위치가 각각 고정이고, 배너가 지도 위에 겹친다. 배경도 잔디톤 → **검정**(Figma). */
  box-sizing: border-box;
  background: #000;
  z-index: 30;
  overflow: hidden;
}

@supports (width: min(1px, 1vw)) {
  .msm {
    --msm-u: min(100vw / 1920, 100vh / 1200);
  }
}

/* 지도 영역 — Figma 1320x1008 @ (300,168). 위치·최대크기만 맡는다.
   🔴 여기에 마커를 붙이면 안 된다. 지도 종횡비가 지점마다 달라(1920x835 / 4200x2980)
      이미지가 이 상자보다 작게 들어가는데, 프레임 기준 \`%\` 는 이미지 위 지점을 가리키지 않는다. */
.msm-frame {
  position: absolute;
  left: calc(300 * var(--msm-u));
  top: calc(168 * var(--msm-u));
  width: calc(1320 * var(--msm-u));
  height: calc(1008 * var(--msm-u));
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 이미지 상자 = 마커 좌표계. \`line-height: 0\` 이라야 img 아래 여백이 안 생겨 상자가 정확해진다.
   🔴 크기를 주지 않는다 — \`<img>\` 에 딱 맞아야 \`%\` 좌표가 성립한다(검증 E4). */
.msm-stage {
  position: relative;
  line-height: 0;
}

.msm-map {
  display: block;
  /* 🔴 \`object-fit: cover\` 금지 — 서버 좌표가 contain 규약이라 잘리면 마커가 어긋난다.
     프레임 안에 **비율을 지켜 들어가게**만 한다(검증 E4). */
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}

/* ── 마커 ─────────────────────────────────────────────────────────────────
   디자인: 흰 카드 56×56(radius 16, 안쪽 여백 8) + 아래 꼬리 16×12 + 그림자.
   꼬리 끝이 스팟 좌표를 가리키도록 전체를 위로 올린다(카드 56 + 꼬리 12 = 68). */
.msm-pin {
  position: absolute;
  /* 군집 오프셋(--msm-dx/dy, 디자인 px 배수)을 여기서 환산한다 — 컴포넌트는 숫자만 넘긴다.
     기본값 0 이라 단독 스팟은 기존 위치 그대로다. */
  transform: translate(
    calc(-50% + var(--msm-dx, 0) * var(--msm-u)),
    calc(-68 * var(--msm-u) + var(--msm-dy, 0) * var(--msm-u))
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  filter: drop-shadow(0 calc(4 * var(--msm-u)) calc(6 * var(--msm-u)) rgba(0, 0, 0, 0.4));
}

.msm-pin-card {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(56 * var(--msm-u));
  height: calc(56 * var(--msm-u));
  padding: calc(8 * var(--msm-u));
  box-sizing: border-box;
  border-radius: calc(16 * var(--msm-u));
  background: #fff;
}

/* 아이콘 40×40 — 미완료=초록 느낌표 / 완료=주황 체크 (사용자 지정 R5) */
.msm-pin-glyph {
  width: calc(40 * var(--msm-u));
  height: calc(40 * var(--msm-u));
  padding: calc(6 * var(--msm-u));
  box-sizing: border-box;
  border-radius: calc(10 * var(--msm-u));
  background: #1e7d32; /* 미완료 */
}

.msm-pin-card--done .msm-pin-glyph {
  background: #ff5816; /* 완료 — 브랜드 오렌지(안내판 강조색과 동일) */
}

/* 꼬리 — 카드와 같은 흰색 삼각형(16×12) */
.msm-pin-tail {
  width: 0;
  height: 0;
  border-left: calc(8 * var(--msm-u)) solid transparent;
  border-right: calc(8 * var(--msm-u)) solid transparent;
  border-top: calc(12 * var(--msm-u)) solid #fff;
}

/* 완료 핀이 미완료 핀 위로 오게 — 디자인처럼 겹칠 때 상태가 가려지지 않는다. */
.msm-pin--done {
  z-index: 1;
}

/* ── 배너 ─────────────────────────────────────────────────────────────────
   Figma \`3379:44594\`(시작 안내) / \`3379:44803\`(진행 중) — 두 프레임 공용.
   2026-08-19 개편: 옛 진행도 알약("미션을 얼마나 완료했나요? N/M")을 대체한다.

   원본 1920x1200 좌표: 배너 780x320 @ (570,20).
   내부 텍스트는 Figma 가 **페이지 절대좌표**로 두었으므로 배너 기준으로 환산했다 —
     1행 top 142 → 122,  2행 top 205 → 185,  아이콘 (938.15,57.28) → (368.15,37.28)

   🔴 배너는 지도 **위에 겹친다**(Figma). 2026-08-05 에 "알약이 지도를 가린다"는 이유로
      쌓기 배치로 바꿨던 이력이 있으므로, 가림 여부는 배포 후 실측으로 확인한다.
   🔴 \`pointer-events: none\` — 5초 자동 복귀 화면이라 아무것도 눌리지 않아야 한다. */
.msm-banner {
  position: absolute;
  left: calc(570 * var(--msm-u));
  top: calc(20 * var(--msm-u));
  width: calc(780 * var(--msm-u));
  height: calc(320 * var(--msm-u));
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
  color: #f4e6c1;
  font-family: 'GosanjaOTF', 'AndongKaturi', sans-serif;
  font-weight: 400;
  text-align: center;
  pointer-events: none;
  z-index: 2;
}

.msm-banner-icon {
  position: absolute;
  left: calc(368.15 * var(--msm-u));
  top: calc(37.28 * var(--msm-u));
  width: calc(43.71 * var(--msm-u));
  height: calc(43.71 * var(--msm-u));
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / contain;
}

.msm-banner-title {
  position: absolute;
  left: 0;
  top: calc(122 * var(--msm-u));
  width: 100%;
  margin: 0;
  font-size: calc(38 * var(--msm-u));
  line-height: 1.3;
}

.msm-banner-text {
  position: absolute;
  left: 0;
  top: calc(185 * var(--msm-u));
  width: 100%;
  margin: 0;
  font-size: calc(52 * var(--msm-u));
  line-height: 1.3;
}
`, "",{"version":3,"sources":["webpack://./src/components/quest/MissionStatusMap.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF;EACE,8DAA8D;EAC9D,gBAAgB;;EAEhB,eAAe;EACf,QAAQ;EACR;;gDAE8C;EAC9C;2DACyD;EACzD,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;;8DAE8D;AAC9D;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;EAChC,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;yDACyD;AACzD;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd;yCACuC;EACvC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;;uDAEuD;AACvD;EACE,kBAAkB;EAClB;kCACgC;EAChC;;;GAGC;EACD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uFAAuF;AACzF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB,EAAE,QAAQ;AAC/B;;AAEA;EACE,mBAAmB,EAAE,8BAA8B;AACrD;;AAEA,8BAA8B;AAC9B;EACE,QAAQ;EACR,SAAS;EACT,qDAAqD;EACrD,sDAAsD;EACtD,8CAA8C;AAChD;;AAEA,iDAAiD;AACjD;EACE,UAAU;AACZ;;AAEA;;;;;;;;;;+DAU+D;AAC/D;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,gCAAgC;EAChC,gFAA0F;EAC1F,cAAc;EACd,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,iCAAiC;EACjC,kCAAkC;EAClC,8EAA4F;AAC9F;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,kCAAkC;EAClC,gBAAgB;AAClB","sourcesContent":["/**\n * 미션 상태 지도 (Figma 2483:75533).\n *\n * 🔴 좌표 정합의 핵심은 CSS 계산이 아니라 **구조**다.\n *    `.msm-stage` 가 `<img>` 를 감싸 **이미지 렌더 크기 그대로** 줄어들고, 마커는 그 안에서\n *    `%` 로 놓인다. 그래서 화면 해상도·화면비가 무엇이든 마커가 지도 위 같은 지점에 붙는다.\n *    (안내판에서 vw/vh 로 좌표를 계산하다 16:10 이 아닌 화면에서 어긋난 사고의 교훈 —\n *     계산을 없애는 쪽이 계산을 맞추는 쪽보다 안전하다.)\n *\n * 크기·타이포는 디자인 1920×1200 기준을 적고 `--msm-u`(디자인 1px 의 실제 길이)로 환산한다.\n */\n\n.msm {\n  /* 안내판과 같은 규약 — 확대하지 않고 비율을 지킨다(min). @supports 가 아래에서 덮어쓴다. */\n  --msm-u: 0.667px;\n\n  position: fixed;\n  inset: 0;\n  /* 🔴 헤더를 지도 **위에 겹치지 않고 위쪽에 쌓는다**(사용자 요청 2026-08-05).\n     디자인(2483:75533)은 알약이 지도 위에 떠 있으나, 실제 지도는 상단까지 내용이 차 있어\n     글자가 지도를 가렸다. 세로 흐름으로 바꿔 헤더 아래에 지도가 오게 한다. */\n  /* 🔴 2026-08-19 — 쌓기(flex column) → **절대배치**로 바꿨다. 새 Figma 는 지도와 배너의\n     위치가 각각 고정이고, 배너가 지도 위에 겹친다. 배경도 잔디톤 → **검정**(Figma). */\n  box-sizing: border-box;\n  background: #000;\n  z-index: 30;\n  overflow: hidden;\n}\n\n@supports (width: min(1px, 1vw)) {\n  .msm {\n    --msm-u: min(100vw / 1920, 100vh / 1200);\n  }\n}\n\n/* 지도 영역 — Figma 1320x1008 @ (300,168). 위치·최대크기만 맡는다.\n   🔴 여기에 마커를 붙이면 안 된다. 지도 종횡비가 지점마다 달라(1920x835 / 4200x2980)\n      이미지가 이 상자보다 작게 들어가는데, 프레임 기준 `%` 는 이미지 위 지점을 가리키지 않는다. */\n.msm-frame {\n  position: absolute;\n  left: calc(300 * var(--msm-u));\n  top: calc(168 * var(--msm-u));\n  width: calc(1320 * var(--msm-u));\n  height: calc(1008 * var(--msm-u));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* 이미지 상자 = 마커 좌표계. `line-height: 0` 이라야 img 아래 여백이 안 생겨 상자가 정확해진다.\n   🔴 크기를 주지 않는다 — `<img>` 에 딱 맞아야 `%` 좌표가 성립한다(검증 E4). */\n.msm-stage {\n  position: relative;\n  line-height: 0;\n}\n\n.msm-map {\n  display: block;\n  /* 🔴 `object-fit: cover` 금지 — 서버 좌표가 contain 규약이라 잘리면 마커가 어긋난다.\n     프레임 안에 **비율을 지켜 들어가게**만 한다(검증 E4). */\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n}\n\n/* ── 마커 ─────────────────────────────────────────────────────────────────\n   디자인: 흰 카드 56×56(radius 16, 안쪽 여백 8) + 아래 꼬리 16×12 + 그림자.\n   꼬리 끝이 스팟 좌표를 가리키도록 전체를 위로 올린다(카드 56 + 꼬리 12 = 68). */\n.msm-pin {\n  position: absolute;\n  /* 군집 오프셋(--msm-dx/dy, 디자인 px 배수)을 여기서 환산한다 — 컴포넌트는 숫자만 넘긴다.\n     기본값 0 이라 단독 스팟은 기존 위치 그대로다. */\n  transform: translate(\n    calc(-50% + var(--msm-dx, 0) * var(--msm-u)),\n    calc(-68 * var(--msm-u) + var(--msm-dy, 0) * var(--msm-u))\n  );\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  filter: drop-shadow(0 calc(4 * var(--msm-u)) calc(6 * var(--msm-u)) rgba(0, 0, 0, 0.4));\n}\n\n.msm-pin-card {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: calc(56 * var(--msm-u));\n  height: calc(56 * var(--msm-u));\n  padding: calc(8 * var(--msm-u));\n  box-sizing: border-box;\n  border-radius: calc(16 * var(--msm-u));\n  background: #fff;\n}\n\n/* 아이콘 40×40 — 미완료=초록 느낌표 / 완료=주황 체크 (사용자 지정 R5) */\n.msm-pin-glyph {\n  width: calc(40 * var(--msm-u));\n  height: calc(40 * var(--msm-u));\n  padding: calc(6 * var(--msm-u));\n  box-sizing: border-box;\n  border-radius: calc(10 * var(--msm-u));\n  background: #1e7d32; /* 미완료 */\n}\n\n.msm-pin-card--done .msm-pin-glyph {\n  background: #ff5816; /* 완료 — 브랜드 오렌지(안내판 강조색과 동일) */\n}\n\n/* 꼬리 — 카드와 같은 흰색 삼각형(16×12) */\n.msm-pin-tail {\n  width: 0;\n  height: 0;\n  border-left: calc(8 * var(--msm-u)) solid transparent;\n  border-right: calc(8 * var(--msm-u)) solid transparent;\n  border-top: calc(12 * var(--msm-u)) solid #fff;\n}\n\n/* 완료 핀이 미완료 핀 위로 오게 — 디자인처럼 겹칠 때 상태가 가려지지 않는다. */\n.msm-pin--done {\n  z-index: 1;\n}\n\n/* ── 배너 ─────────────────────────────────────────────────────────────────\n   Figma `3379:44594`(시작 안내) / `3379:44803`(진행 중) — 두 프레임 공용.\n   2026-08-19 개편: 옛 진행도 알약(\"미션을 얼마나 완료했나요? N/M\")을 대체한다.\n\n   원본 1920x1200 좌표: 배너 780x320 @ (570,20).\n   내부 텍스트는 Figma 가 **페이지 절대좌표**로 두었으므로 배너 기준으로 환산했다 —\n     1행 top 142 → 122,  2행 top 205 → 185,  아이콘 (938.15,57.28) → (368.15,37.28)\n\n   🔴 배너는 지도 **위에 겹친다**(Figma). 2026-08-05 에 \"알약이 지도를 가린다\"는 이유로\n      쌓기 배치로 바꿨던 이력이 있으므로, 가림 여부는 배포 후 실측으로 확인한다.\n   🔴 `pointer-events: none` — 5초 자동 복귀 화면이라 아무것도 눌리지 않아야 한다. */\n.msm-banner {\n  position: absolute;\n  left: calc(570 * var(--msm-u));\n  top: calc(20 * var(--msm-u));\n  width: calc(780 * var(--msm-u));\n  height: calc(320 * var(--msm-u));\n  background: url('../../assets/quest/mission_map_banner.webp') no-repeat center / 100% 100%;\n  color: #f4e6c1;\n  font-family: 'GosanjaOTF', 'AndongKaturi', sans-serif;\n  font-weight: 400;\n  text-align: center;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.msm-banner-icon {\n  position: absolute;\n  left: calc(368.15 * var(--msm-u));\n  top: calc(37.28 * var(--msm-u));\n  width: calc(43.71 * var(--msm-u));\n  height: calc(43.71 * var(--msm-u));\n  background: url('../../assets/quest/mission_map_banner_icon.svg') no-repeat center / contain;\n}\n\n.msm-banner-title {\n  position: absolute;\n  left: 0;\n  top: calc(122 * var(--msm-u));\n  width: 100%;\n  margin: 0;\n  font-size: calc(38 * var(--msm-u));\n  line-height: 1.3;\n}\n\n.msm-banner-text {\n  position: absolute;\n  left: 0;\n  top: calc(185 * var(--msm-u));\n  width: 100%;\n  margin: 0;\n  font-size: calc(52 * var(--msm-u));\n  line-height: 1.3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
